export const CUSTOMER_LTV_PERIODS = [
  0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360, 390, 420, 450,
  480, 510, 540, 570, 600, 630, 660, 690, 720,
] as const;
